import { gql } from "@apollo/client";

export const AuthQueries = {
  FETCH_PERMISSIONS: gql`
    query {
      authoring_permissionList(pagePath: "")
    }
  `,
  // Brand data lives in the SiteInfo config bucket (same query AddSite.tsx uses).
  FETCH_BRAND_DETAILS: gql`
    query FETCH_BRAND_DETAILS($page: String!) {
      authoring_getSitedetails(siteConfig: SiteInfo, page: $page)
    }
  `,
};
